const FUC_CODE = {
  BK_KDB: '002',
  // KDB산업은행
  BK_IBK: '003',
  // 기업은행
  BK_KB: '004',
  // KB국민은행
  BK_SH: '007',
  // 수협중앙회
  BK_EXIM: '008',
  // 한국수출입은행
  BK_NH: '011',
  // 농협중앙회
  BK_WOORI: '020',
  // 우리은행
  BK_SC: '023',
  // SC제일은행
  BK_CITI: '027',
  // 씨티은행
  BK_DAEGU: '031',
  // iM뱅크(대구은행)
  BK_BUSAN: '032',
  // 부산은행
  BK_KWANGJU: '034',
  // 광주은행
  BK_JEJU: '035',
  // 제주은행
  BK_JEONBUK: '037',
  // 전북은행
  BK_KYOUNGNAM: '039',
  // 경남은행
  BK_KFCC: '045',
  // 새마을금고
  BK_CU: '048',
  // 신용협동조합중앙회
  BK_HSBC: '054',
  // HSBC은행
  BK_DEUTSCH: '055',
  // 도이치
  BK_BOA: '060',
  // BOA
  BK_BNP: '061',
  // BNP파리바
  BK_JPMORGAN: '057',
  // JP모간
  BK_ICBC: '062',
  // 중국공상
  BK_CHINA: '063',
  // 중국은행
  BK_CCB: '067',
  // 중국건설
  BK_NFCF: '064',
  // 산림조합중앙회
  BK_EPOST: '071',
  // 우체국
  BK_HANA: '081',
  // 하나은행
  BK_SHINHAN: '088',
  // 신한은행
  BK_K: '089',
  // 케이뱅크
  BK_KAKAO: '090',
  // 카카오뱅크
  BK_TOSS: '092',
  // 토스
  BK_NHCENTRAL: 'N893',
  // 농협중앙회
  BK_SHCENTRAL: 'N894',
  // 수협중앙회

  SB_COMMON: '050',
  // 저축은행중앙회
  SB_SBI: '103',
  // SBI저축은행
  SB_SBI2: 'N823',
  // SBI저축은행_2
  SB_WELCOME: '105',
  // 웰컴저축은행
  SB_JTCHINE: 'N801',
  // JT친애저축은행
  SB_SSIN: 'N802',
  // 상상인저축은행
  SB_PEPPER: 'N803',
  // 페퍼저축은행
  SB_BNK: 'N804',
  // BNK저축은행
  SB_IBK: 'N805',
  // IBK저축은행
  SB_DAOL: 'N806',
  // 다올저축은행
  SB_DONGWONJEIL: 'N807',
  // 동원제일저축은행
  SB_LENDIT: 'N808',
  // 렌딧
  SB_SHINHAN: 'N809',
  // 신한저축은행
  SB_YEKARAM: 'N810',
  // 예가람저축은행
  SB_WOORIFIN: 'N811',
  // 우리금융저축은행
  SB_KIWOOMYES: 'N812',
  // 키움예스저축은행
  SB_HANWHA: 'N813',
  // 한화저축은행
  SB_OK: 'N814',
  // OK저축은행
  SB_KOREAINVEST: 'N815',
  // 한국투자저축은행
  SB_DB: 'N816',
  // DB저축은행
  SB_HB: 'N817',
  // HB저축은행
  SB_JT: 'N818',
  // JT저축은행
  SB_KB: 'N819',
  // KB저축은행
  SB_ACUON: 'N820',
  // 애큐온저축은행
  SB_NH: 'N821',
  // NH저축은행
  SB_OSB: 'N822',
  // OSB저축은행
  SB_COREA: 'N824',
  // 고려저축은행
  SB_DAISHIN: 'N825',
  // 대신저축은행
  SB_MOA: 'N826',
  // 모아저축은행
  SB_SMART: 'N827',
  // 스마트저축은행
  SB_JINJU: 'N830',
  // 진주저축은행
  SB_KIWOOM: 'N831',
  // 키움저축은행
  SB_HANA: 'N833',
  // 하나저축은행
  SB_YOONGCHANG: 'N835',
  // 융창저축은행
  SB_CK: 'N844',
  // CK저축은행
  SB_DH: 'N845',
  // DH저축은행
  SB_SNT: 'N846',
  // SNT저축은행
  SB_KOOKJE: 'N847',
  // 국제저축은행
  SB_KUMHWA: 'N848',
  // 금화저축은행
  SB_NAMYANG: 'N849',
  // 남양저축은행
  SB_DAEMYUNG: 'N850',
  // 대명저축은행
  SB_DAEBAEK: 'N851',
  // 대백저축은행
  SB_DAEAH: 'N852',
  // 대아저축은행
  SB_DAEWON: 'N853',
  // 대원저축은행
  SB_DAEHAN: 'N854',
  // 대한저축은행
  SB_DOUBLE: 'N855',
  // 더블저축은행
  SB_THEK: 'N856',
  // 더케이저축은행
  SB_DONGYANG: 'N857',
  // 동양저축은행
  SB_DREAM: 'N858',
  // 드림저축은행
  SB_RAON: 'N859',
  // 라온저축은행
  SB_MUSTSAMIL: 'N860',
  // 머스트삼일저축은행
  SB_MK: 'N861',
  // 민국저축은행
  SB_BARO: 'N862',
  // 바로저축은행
  SB_BOORIM: 'N863',
  // 부림저축은행
  SB_SAMJUNG: 'N864',
  // 삼정저축은행
  SB_SAMHO: 'N865',
  // 삼호저축은행
  SB_SERAM: 'N866',
  // 세람저축은행
  SB_CENTRAL: 'N867',
  // 센트럴저축은행
  SB_SOLBRAIN: 'N868',
  // 솔브레인저축은행
  SB_SKY: 'N869',
  // 스카이저축은행
  SB_STAR: 'N870',
  // 스타저축은행
  SB_ASAN: 'N871',
  // 아산저축은행
  SB_ANGUK: 'N872',
  // 안국저축은행
  SB_ANYANG: 'N873',
  // 안양저축은행
  SB_MS: 'N874',
  // 엠에스저축은행
  SB_YOUNGJIN: 'N875',
  // 영진저축은행
  SB_OHSUNG: 'N876',
  // 오성저축은행
  SB_OHTOO: 'N877',
  // 오투저축은행
  SB_WOORI: 'N878',
  // 우리저축은행
  SB_UNION: 'N879',
  // 유니온저축은행
  SB_YUANTA: 'N880',
  // 유안타저축은행
  SB_INSUNG: 'N882',
  // 인성저축은행
  SB_INCHEON: 'N883',
  // 인천저축은행
  SB_CHOEUN: 'N884',
  // 조은저축은행
  SB_CHOHEUNG: 'N885',
  // 조흥저축은행
  SB_TRUE: 'N886',
  // 참저축은행
  SB_CHUNGJU: 'N887',
  // 청주저축은행
  SB_PYUNGTAEK: 'N888',
  // 평택저축은행
  SB_PURUN: 'N889',
  // 푸른저축은행
  SB_HANSUNG: 'N890',
  // 한성저축은행
  SB_HEUNGKUK: 'N891',
  // 흥국저축은행
  SB_SSINPLUS: 'N892',
  // 상상인플러스저축은행

  CAPITAL_WOORIF: '299',
  // 우리금융캐피탈
  CAPITAL_DGB: '301',
  // iM캐피탈(DGB캐피탈)
  CAPITAL_BNK: '302',
  // BNK캐피탈
  CAPITAL_LOTTE: '303',
  // 롯데캐피탈
  CAPITAL_HYUNDAI: '304',
  // 현대캐피탈
  CAPITAL_JB_WOORI: '305',
  // JB우리캐피탈
  CAPITAL_NH: '306',
  // NH농협캐피탈
  CAPITAL_ACUON: '307',
  // 애큐온캐피탈
  CAPITAL_KB: '308',
  // KB캐피탈
  CAPITAL_HANKOOK: '309',
  // 한국캐피탈
  CAPITAL_HANA: '310',
  // 하나캐피탈
  CAPITAL_KICF: '313',
  // 한국투자캐피탈
  CAPITAL_MIRAE: 'N828',
  // 미래에셋캐피탈
  CAPITAL_WELCOME: 'N829',
  // 웰컴캐피탈
  CAPITAL_PEOPLE_FUND: 'N832',
  // 피플펀드
  CAPITAL_OK: 'N834',
  // OK캐피탈
  CAPITAL_8PERCENT: 'N911',
  // 에잇퍼센트
  CAPITAL_HONESTFUND: 'N912',
  // 어니스트펀드

  CD_WOORI: '041',
  // 우리카드
  CD_BC: '361',
  // BC카드
  CD_SAMSUNG: '365',
  // 삼성카드
  CD_SHINHAN: '366',
  // 신한카드
  CD_HYUNDAI: '367',
  // 현대카드
  CD_LOTTE: '368',
  // 롯데카드
  CD_HANA: '374',
  // 하나카드
  CD_KB: '381',
  // KB국민카드
  CD_NH: '371',
  // NH농협카드
  CD_IBK: 'N908',
  // IBK카드
  CD_NAVER_PAY: 'N909',
  // 네이버페이카드
  CD_KAKAO_PAY: 'N910',
  // 카카오페이카드

  IS_KYOBOLIFE: '436',
  // 교보생명
  IS_DONGYANG: '402',
  // 동양생명
  IS_LINALIFE: '435',
  // 라이나생명
  IS_LOTTE: '445',
  // 롯데손해
  IS_MERITZFIRE: '448',
  // 메리츠화재
  IS_MET: 'N896',
  // 메트라이프생명
  IS_MIRAE: '431',
  // 미래에셋생명
  IS_SAMSUNGLIFE: '452',
  // 삼성생명
  IS_SAMSUNGFIRE: '441',
  // 삼성화재
  IS_SHINHAN: '438',
  // 신한라이프
  IS_KOREAPOST: 'N897',
  // 우체국
  IS_CHUBBLIFE: '460',
  // 처브라이프생명
  IS_KB_PRUDENTIAL: '439',
  // KB라이프생명
  IS_FUBON: '434',
  // 푸본현대생명
  IS_HANALIFE: '401',
  // 하나생명
  IS_HANAFIRE: 'N898',
  // 하나손해
  IS_HANWHALIFE: '432',
  // 한화생명
  IS_HANWHAFIRE: '454',
  // 한화손해
  IS_HI: '442',
  // 현대해상
  IS_HEUNGKUKLIFE: '453',
  // 흥국생명
  IS_ABL: '437',
  // ABL생명
  IS_HEUNGKUKFIRE: '403',
  // 흥국화재
  IS_AIGFIRE: 'N900',
  // AIG손해
  IS_AXA: '447',
  // AXA손해
  IS_BNPLIFE: 'N901',
  // BNP파리바생명
  IS_BNPFIRE: 'N902',
  // BNP파리바손해
  IS_DBLIFE: '457',
  // DB생명
  IS_DBFIRE: '443',
  // DB손해
  IS_DGB: '456',
  // DGB생명
  IS_KBFIRE: '444',
  // KB손해
  IS_KDB: '458',
  // KDB생명
  IS_MG: 'N903',
  // MG손해
  IS_NHLIFE: 'N904',
  // NH농협생명
  IS_NHFIRE: 'N905',
  // NH농협손해
  IS_CARROT: 'N895',
  // 캐롯손해
  IS_LINAFIRE: 'N899',
  // 라이나손해보험
  IS_AIGLIFE: '455',
  // AIA생명(AIG)
  IS_LIFEPLANET: '433',
  // 교보라이프플래닛
  IS_SGIC: '094',
  // 서울보증보험
  IS_IBKI: 'N907',
  // IBK연금
  IS_THEK: 'N906',
  // THE-K교직원공제회

  IV_YUANTA: '209',
  // 유안타증권
  IV_KB: '218',
  // KB증권
  IV_SSIN: '221',
  IV_HANYANG: '222',
  IV_LEADING: '223',
  IV_BNK: '224',
  // BNK투자
  IV_IBK: '225',
  // IBK투자
  IV_DAOL: '227',
  // 다올투자증권 - (구) KTB투자증권
  IV_MIRAE: '238',
  // 미래에셋증권
  IV_SAMSUNG: '240',
  // 삼성증권
  IV_KOREA: '243',
  // 한국투자증권
  IV_NH: '247',
  // NH투자증권
  IV_KYOBO: '261',
  // 교보증권
  IV_HI: '262',
  // 하이투자증권
  IV_HM: '263',
  // 현대차증권
  IV_KIWOOM: '264',
  // 키움증권
  IV_LS: '265',
  // LS증권
  IV_SK: '266',
  // SK증권
  IV_DAISHIN: '267',
  // 대신증권
  IV_HANWHA: '269',
  // 한화투자증권
  IV_HANA: '270',
  // 하나금융투자
  IV_TOSS: '271',
  // 토스증권
  IV_SHINHAN: '278',
  // 신한금융투자
  IV_DBFI: '279',
  // DB금융투자
  IV_EUGENE: '280',
  // 유진투자증권
  IV_MERITZ: '287',
  // 메리츠
  IV_KAKAOPAY: '288',
  // 카카오페이증권
  IV_BOOKOOK: '290',
  // 부국증권
  IV_SHINYOUNG: '291',
  // 신영증권
  IV_CAPE: '292',
  // 케이피에이치증권
  IV_HANKUK: '293',
  // 한국증권금융
  IV_FOSS: '294',
  // 포스증권
  IV_WOORI: '295',
  // 우리투자증권
  IV_DS: 'N837',
  // DS투자증권
  IV_KR: 'N838',
  // KR투자증권
  IV_MACQUARIE: 'N839',
  // 맥쿼리증권
  IV_YUHWA: 'N840',
  // 유화증권
  IV_KTB: 'N841',
  // 케이티비투자증권
  IV_KOREAASSET: 'N842',
  // 코리아에셋투자증권
  IV_HEUNGKUK: 'N843' // 흥국증권
};
var FUC_CODE$1 = FUC_CODE;

export { FUC_CODE$1 as default };
